import {
  Component,
  h,
  Element,
  Prop, State, Watch

} from '@stencil/core';

@Component({
  tag: 'uiaas-section-loader',
  styleUrl: 'section-loader.scss',
  shadow: false
})
export class SectionLoader {

  @Element() el: HTMLElement;

  @Prop() readonly contentReady: boolean;

  private observer: IntersectionObserver;

  @Prop() readonly content;

  @State() isVisible = false;


  private isIntersectionSupported = ('IntersectionObserver' in window);
  private onIntersection = async (entries: IntersectionObserverEntry[]) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          this.disconnectObserver();
          this.isVisible = true;
        }
      }
  };

  private disconnectObserver = () => {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null; // Clear the reference to enable garbage collection
      }
  };

  @Watch('contentReady')
  contentReadyHandler(newValue: boolean) {
      if (newValue) {
        this.handleIntersection();
      }
  }
  private handleIntersection() {
      // Check if the observer has already been set up to avoid unnecessary re-initialization
      if (this.observer) {
        return;
      }
      const section = this.el.querySelector('section');
      if (section) {
        const options = {
          root: null, // Use the viewport as the bounding box.
          rootMargin: '0px', // No margin, so the callback triggers exactly at the viewport edge.
        };
        this.observer = new IntersectionObserver(this.onIntersection, options);
        this.observer.observe(section);
      }
  }

  componentDidLoad() {
      this.handleIntersection();
  }


  disconnectedCallback() {
      this.disconnectObserver();
  }

  render() {
      const contentIsVisible = (this.isVisible && this.contentReady) || !this.isIntersectionSupported;
      return (
        <section class='section-loader'>
          { contentIsVisible ? this.content : ''}
        </section>
      );
  }
}
